<template>
  <div class="modal-overlay">
    <div v-if="loading" class="mmodal-content">
      <loader />
    </div>

    <div v-if="!loading" class="mmodal-content">
      <!-- HEADER -->
      <div class="modal-header">
        <h5 class="modal-title">Select Bill Type</h5>
        <button type="button" class="close" @click="closeModal">×</button>
      </div>

      <!-- BODY -->
      <div class="modal-body">
        <p class="helper-text">
          Choose how this invoice will be billed. The selected option determines
          the pricing applied to all services.
        </p>

        <!-- BILL TYPE SELECT -->
        <div class="form-group">
          <label class="form-label">Bill Type</label>
          <select class="form-control" v-model="bill_type">
            <option disabled value="">-- Select Bill Type --</option>
            <option value="cash">Cash</option>
            <option value="insurance">Insurance</option>
            <option value="corporate">Invoice / Corporate</option>
          </select>
        </div>

        <!-- DESCRIPTION -->
        <div v-if="bill_type" class="bill-description">
          <div v-if="bill_type === 'cash'">
            <strong>Cash:</strong>
            Patient pays directly. Standard cash prices will be applied.
          </div>

          <div v-if="bill_type === 'insurance'">
            <strong>Insurance:</strong>
            Charges will follow the insurance tariff. Copay and limits may
            apply.
          </div>

          <div v-if="bill_type === 'corporate'">
            <strong>Invoice / Corporate:</strong>
            Prices will be billed to a company or organization under contract.
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="closeModal">Cancel</button>
        <button class="btn btn-primary" :disabled="!bill_type" @click="save">
          Confirm
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "../../special_clinics/dialysis/loader.vue";
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "BillTypeModal",

  props: {
    invoice_id: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      bill_type: "",
      loading: false,
    };
  },
  components: {
    loader,
  },

  methods: {
    closeModal() {
      this.$emit("close-conf");
    },

    async save() {
      this.loading = true;
      const url = "submit_invoice_bill_tarrif";

      const req_body = {
        invoice_id: this.invoice_id,
        bill_type: this.bill_type,
      };
      console.log(req_body);

      await generalApiRequest(url, "POST", req_body, 1);
      this.loading = false;
      this.closeModal();
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.mmodal-content {
  background: #fff;
  width: 420px;
  max-width: 90%;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
}

.modal-header {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  margin: 0;
  font-weight: 600;
}

.modal-body {
  padding: 1.25rem;
}

.helper-text {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 1rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-label {
  font-weight: 600;
  margin-bottom: 0.4rem;
  display: block;
}

.form-control {
  width: 100%;
  padding: 0.55rem 0.75rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 0.95rem;
}

.bill-description {
  margin-top: 1rem;
  padding: 0.75rem;
  background: #f8f9fa;
  border-left: 4px solid #0d6efd;
  font-size: 0.9rem;
  color: #333;
  border-radius: 4px;
}

.modal-footer {
  padding: 1rem 1.25rem;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.btn {
  padding: 0.45rem 0.9rem;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
}

.btn-primary {
  background: #0d6efd;
  color: #fff;
  border: none;
}

.btn-primary:disabled {
  background: #aac8f7;
  cursor: not-allowed;
}

.btn-secondary {
  background: #e0e0e0;
  border: none;
}

.close {
  background: #dc3545;
  border: none;
  color: #fff;
  font-size: 1.25rem;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  cursor: pointer;
}
</style>
